import React, { useState, useEffect } from 'react';
import Lenis from '@studio-freight/lenis';

import Loader from './components/Loader';
import CustomCursor from './components/CustomCursor';
import Header from './components/Header';
import Footer from './components/Footer';

import Hero from './sections/Hero';
import Marquee from './sections/Marquee';
import Manifesto from './sections/Manifesto';
import Services from './sections/Services';
import Products from './sections/Products';
import Portfolio from './sections/Portfolio';
import FreeOfferings from './sections/FreeOfferings';
import Careers from './sections/Careers';
import Contact from './sections/Contact';

import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize Lenis Smooth Scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[#f8fafc] min-h-screen text-slate-900 relative">
      {/* Loading Screen */}
      {loading && <Loader onLoaded={() => setLoading(false)} />}

      {/* Custom Glowing Cursor */}
      <CustomCursor />

      {/* Top Header Navigation */}
      <Header />

      {/* Main Page Sections */}
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Products />
        <Portfolio />
        <FreeOfferings />
        <Careers />
        <Contact />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
